module.exports = __webpack_public_path__ + "img/36.5c63bd5d.jpg";